const base = {
  url: "//sdk.qcplay.com", //生成环境
  // url: "//tsdk.qcplay.com", //测试环境
  wechat: "//api.qingcigame.com",
}

export default base
